skrilla.service('addressService', function() {

    const formatAddress = function(user) {
        let address = ""
        if (user.streetNumber) {
            address += user.streetNumber + " "
        }
        if (user.street) {
            address += user.street + " "
        }
        if (user.postCode) {
            address += user.postCode + ", "
        }
        if (user.suburb) {
            address += user.suburb + " "
        }
        if (user.state) {
            address += user.state + ", "
        }
        if (user.country) {
            address += user.country
        }
        return address
    }

    return {
        formatAddress: formatAddress,
    };

});